import React from "react";
import styled from "styled-components";
import { Icons } from "@/assets/icons";
import { useLanguage } from "../../contexts/LanguageContext";
import {
  getMiniProjectTranslation,
  getMiniProjectDetail,
} from "../../translations/miniProjectsAndJS30";

const MiniProjectCard = ({ translationKey, siteLink, GhLink, cardImg }) => {
  const { language } = useLanguage();
  const title = getMiniProjectDetail(language, translationKey, "title");
  const description = getMiniProjectDetail(
    language,
    translationKey,
    "description"
  );
  const visitSiteText = getMiniProjectTranslation(language, "visitSite");

  return (
    <CardBody>
      <a href={siteLink} target="blank_">
        {" "}
        <h2>{visitSiteText}</h2>
        <img id="image" src={cardImg} alt={title} />
      </a>
      <a href={GhLink} target="_blank" rel="noreferrer">
        <img id="icon" src={Icons.github} alt="Github" />
      </a>
      <CardTitle>
        <h4>{title}</h4>
      </CardTitle>
      <CardDesc>
        <p>{description}</p>
      </CardDesc>
    </CardBody>
  );
};

export default MiniProjectCard;

const CardBody = styled.div`
  border: 2px solid rgba(83, 83, 83, 0.3);
  background-color: rgba(200, 233, 250, 0.1);
  max-width: 200px;
  max-height: 295px;
  margin: 20px;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  @media (max-width: 768px) {
    max-height: 100%;
  }

  &:hover {
    border: 2px solid rgba(83, 83, 83, 0.6);
    h2 {
      z-index: 1;
    }
    #image {
      opacity: 0.5;
    }
  }

  h2 {
    position: absolute;
    top: 25%;
    left: 23%;
    color: black;
    font-weight: 900;
    z-index: -1;
    background-color: rgba(250, 250, 250, 0.6);
    padding: 2px 9px;
    border-radius: 15px;
  }

  img {
    width: 175px;
    height: 150px;
    object-fit: cover;
    z-index: 0;
  }

  #icon {
    height: 30px;
    width: 30px;
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 50px;

    &:hover {
      height: 32px;
      width: 32px;
    }
  }
`;

const CardTitle = styled.div`
  margin-bottom: 2px;
`;

const CardDesc = styled.div`
  p {
    text-align: start;
    padding: 0px 10px;
  }
`;
